import { gql } from '@apollo/client'

export default gql`
    mutation updateProductUpdate(
        $institutionCodeProductID: String!
        $updatedKey: String!
        $updatedValue: String!
        $state: String!
        $comments: String!
        $uneditedValue: String!
    ) {
        updateProductUpdate(
            institutionCodeProductID: $institutionCodeProductID
            updatedKey: $updatedKey
            updatedValue: $updatedValue
            state: $state
            comments: $comments
            uneditedValue: $uneditedValue
        ) {
            institutionCodeProductID
            updatedKey
            updatedValue
            uneditedValue
            state
            comments
            dateCreated
            dateUpdated
        }
    }
`
